import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2a56ed9a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "cms-card-block"
};
const _hoisted_3 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_4 = ["width"];
const _hoisted_5 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center",
    "width": "100%",
    "gap": "10px"
  }
};
const _hoisted_6 = {
  key: 1,
  style: {
    "width": "100%"
  }
};
const _hoisted_7 = {
  class: "price-setting"
};
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "cms-module-title mg-t--20"
};
const _hoisted_10 = {
  class: "price-table"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-count"
}, null, -1));

import ActionHeader from '@/views/common/ActionHeader/index.vue';
import PriceTable from '../components/PriceTable.vue';
import { Cycle } from '@/assets/config/dicts';
import { useI18n } from 'vue-i18n';
import { floorNum, formValidator, messageBox } from '@/utils/validate';
import { clearData } from '@/utils/tools';
export default /*#__PURE__*/_defineComponent({
  __name: 'addOrEditPlan',
  props: {
    returnBackFn: {
      type: Function
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const TopFormRef = ref(null);
    const PriceFormRef = ref(null); // 标题配置

    const headerConfig = reactive({
      title: '新增促销方案',
      btnList: [{
        label: '返回',
        func: () => {
          props.returnBackFn();
        }
      }]
    });
    const mainBrandList = ref([{
      label: '主品牌一',
      value: 1
    }, {
      label: '主品牌二',
      value: 2
    }]);
    const subBrandList = ref([{
      label: '子品牌一',
      value: 1
    }, {
      label: '子品牌二',
      value: 2
    }, {
      label: '子品牌三三三三三三三',
      value: 3
    }, {
      label: '子品牌四四四四四四四',
      value: 4
    }, {
      label: '子品牌五五五五五五五',
      value: 5
    }]);
    const checkBoxList = ref([{
      label: '点播+直播VIP',
      value: 1
    }, {
      label: '点播VIP',
      value: 2
    }, {
      label: '直播VIP',
      value: 3
    }, {
      label: '单片付费',
      value: 4
    }]);
    const checkServiceList = ref([]);
    const priceTableData = ref([]);
    const actionForm = reactive({
      visible: false,
      loading: false,
      action: 'add',
      formList: [[{
        label: '服务列表',
        prop: 'serviceListName',
        itemSlot: true
      }, {
        label: '产品促销方案名称',
        prop: 'productName',
        required: true,
        widgetType: 'input',
        rules: [{
          required: true,
          message: t('请输入促销方案名称'),
          trigger: 'blur'
        }]
      }], [{
        label: '选择主/子品牌',
        prop: 'mainOrSub',
        required: true,
        itemSlot: true
      }, {
        label: '促销周期',
        prop: 'period',
        required: true,
        widgetType: 'date',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange',
        rules: [{
          required: true,
          message: t('请选择促销周期'),
          trigger: 'change'
        }]
      }], [{
        label: '复用续费方案产品构成',
        prop: 'reuse',
        widgetType: 'Select',
        tdClass: 'reuse'
      }]],
      formData: {
        serviceListName: [],
        productName: '',
        mainBrand: '',
        subBrand: [],
        period: [],
        reuse: ''
      },
      rules: {
        serviceListName: [{
          required: true,
          message: t('请选择服务列表'),
          trigger: 'change'
        }],
        mainBrand: [{
          required: true,
          message: t('请选择主品牌'),
          trigger: 'change'
        }],
        subBrand: [{
          required: true,
          message: t('请选择子品牌'),
          trigger: 'change'
        }]
      }
    }); // 校验价格(美元)输入

    const validatorPrice = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(t('请输入价格')));
      } else if (value == 0 || value == 0.0 || value == 0.00) {
        return callback(new Error(t('请输入大于零的数字')));
      } else {
        if (!floorNum(value, 2)) {
          callback(new Error(t('只允许输入数字')));
        }

        callback();
      } // callback()

    };

    const dialogActionForm = reactive({
      visible: false,
      loading: false,
      action: 'add',
      formList: [[{
        label: '服务列表',
        prop: 'serviceListName',
        widgetType: 'Select',
        list: checkBoxList.value,
        required: true
      }], [{
        label: '服务期',
        prop: 'servicePeriod',
        widgetType: 'Select',
        list: Cycle,
        required: true
      }], [{
        label: '终端显示名称',
        prop: 'name',
        widgetType: 'input',
        required: true
      }], [{
        label: '价格(美元)',
        prop: 'price',
        widgetType: 'input',
        suffix: t('美元'),
        required: true,
        onInput: val => {
          dialogActionForm.formData.price = val.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1');
        }
      }]],
      formData: {
        serviceListName: '',
        servicePeriod: '',
        name: '',
        price: ''
      },
      dialogConfig: {
        title: actionForm.action == 'add' ? '新增' : '编辑',
        destroyOnClose: true
      },
      rules: {
        serviceListName: [{
          required: true,
          message: t('请选择服务列表'),
          trigger: 'change'
        }],
        servicePeriod: [{
          required: true,
          message: t('请选择服务期'),
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: t('请输入终端显示名称'),
          trigger: 'blur'
        }],
        price: [{
          required: true,
          validator: validatorPrice,
          trigger: 'blur'
        }]
      },
      confirm: done => {
        formValidator(PriceFormRef.value.mForm).then(() => {
          if (dialogActionForm.action == 'add') {
            priceTableData.value.push({ ...dialogActionForm.formData
            });
            dialogActionForm.visible = false;
            done();
          } else {
            const {
              index
            } = dialogActionForm.formData;
            priceTableData.value[index] = { ...dialogActionForm.formData
            };
            dialogActionForm.visible = false;
            done();
          }
        }, () => done());
      }
    });

    const onAddPriceBtnClick = () => {
      clearData(dialogActionForm.formData);
      dialogActionForm.action = 'add';
      dialogActionForm.visible = true;
    };

    const onEditPrice = row => {
      dialogActionForm.action = 'edit';
      dialogActionForm.visible = true;
      dialogActionForm.formData = { ...row
      };
    };

    const onDeletePrice = index => {
      console.log(index);
      messageBox('确定删除这条数据吗?').then(() => {
        priceTableData.value.splice(index, 1);
      });
    }; // 主品牌下拉选项发生变化change事件


    const onMainBrandSelectChange = val => {
      TopFormRef.value.validateField('subBrand');
    };

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      const _component_FormItem = _resolveComponent("FormItem");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_ButtomBtns = _resolveComponent("ButtomBtns");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_m_dialog = _resolveComponent("m-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
        model: actionForm.formData,
        ref_key: "TopFormRef",
        ref: TopFormRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [_createElementVNode("table", _hoisted_3, [_createElementVNode("colgroup", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['15%', '35%', '15%', '35%'], (c, i) => {
          return _createElementVNode("col", {
            width: c,
            key: i
          }, null, 8, _hoisted_4);
        }), 64))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionForm.formList, item => {
          return _openBlock(), _createBlock(_component_FormItem, {
            "form-item": item,
            "form-data": actionForm.formData
          }, {
            itemSlot: _withCtx(scope => [scope.prop === 'mainOrSub' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_form_item, {
              style: {
                "flex": "1",
                "height": "100%"
              },
              prop: "mainBrand",
              rules: actionForm.rules.mainBrand
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                style: {
                  "width": "100%"
                },
                modelValue: actionForm.formData.mainBrand,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => actionForm.formData.mainBrand = $event),
                onChange: onMainBrandSelectChange,
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainBrandList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue"])]),
              _: 2
            }, 1032, ["rules"]), _createVNode(_component_el_form_item, {
              style: {
                "flex": "1",
                "height": "100%"
              },
              prop: "subBrand",
              rules: actionForm.rules.subBrand
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                style: {
                  "width": "100%"
                },
                modelValue: actionForm.formData.subBrand,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => actionForm.formData.subBrand = $event),
                multiple: "",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subBrandList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue"])]),
              _: 2
            }, 1032, ["rules"])])) : _createCommentVNode("", true), scope.prop === 'serviceListName' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_form_item, {
              prop: "serviceListName",
              rules: actionForm.rules.serviceListName
            }, {
              default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                modelValue: actionForm.formData.serviceListName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => actionForm.formData.serviceListName = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkBoxList.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_checkbox, {
                    key: index,
                    label: item.value
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                    _: 2
                  }, 1032, ["label"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue"])]),
              _: 2
            }, 1032, ["rules"])])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["form-item", "form-data"]);
        }), 256))])])]),
        _: 1
      }, 8, ["model"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('单价设定')), 1), _createVNode(_component_el_button, {
        class: "el-button el-button--default cms-op-btn cms-op-btn-main",
        onClick: onAddPriceBtnClick
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_10, [_createVNode(PriceTable, {
        modelValue: priceTableData.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => priceTableData.value = $event),
        onOnEditPrice: onEditPrice,
        onOnDeletePrice: onDeletePrice
      }, null, 8, ["modelValue"])])]), _hoisted_11, _createVNode(_component_ButtomBtns, {
        style: {
          "margin-top": "50px"
        },
        onOnCancel: _cache[4] || (_cache[4] = $event => __props.returnBackFn()),
        onOnConfirm: _cache[5] || (_cache[5] = () => {})
      })]), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: dialogActionForm.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dialogActionForm.visible = $event),
        "dialog-config": dialogActionForm.dialogConfig,
        nativeConfig: {
          width: '40%',
          closeOnClickModal: false
        },
        onOnConfirm: dialogActionForm.confirm
      }, {
        default: _withCtx(() => [_createVNode(_component_FormTable, {
          ref_key: "PriceFormRef",
          ref: PriceFormRef,
          "form-list": dialogActionForm.formList,
          "form-data": dialogActionForm.formData,
          rules: dialogActionForm.rules
        }, null, 8, ["form-list", "form-data", "rules"])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"])]);
    };
  }

});